import { render, staticRenderFns } from "./DashboardMainTab.vue?vue&type=template&id=df5e2eba&"
import script from "./DashboardMainTab.vue?vue&type=script&lang=js&"
export * from "./DashboardMainTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df5e2eba')) {
      api.createRecord('df5e2eba', component.options)
    } else {
      api.reload('df5e2eba', component.options)
    }
    module.hot.accept("./DashboardMainTab.vue?vue&type=template&id=df5e2eba&", function () {
      api.rerender('df5e2eba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/dashboard/screens/DashboardScreen/DashboardMainTab.vue"
export default component.exports